import {HeaderColumn, Row} from '@vidazoo/ui-kit';
import {observer} from 'mobx-react';
import {useScheduleReportsListContext} from '../context/ScheduleReportsListContext';
import {ScheduleReportsTableColumns} from '../common/constants';
import {ReactComponent as SearchIcon} from '../../../charts/list/assets/search-small.svg';
import {ReactComponent as ClearIcon} from '../../../charts/list/assets/cancel-small.svg';
import {ReactComponent as IncreaseIcon} from '../../../charts/list/assets/increase-small.svg';
import {ReactComponent as DecreaseIcon} from '../../../charts/list/assets/decrease-small.svg';

const icons = {'icon-search': SearchIcon, 'icon-cancel-small': ClearIcon,
    'icon-increase-small': IncreaseIcon, 'icon-decrease-small': DecreaseIcon};
const renderIcon = (name: string, size: number) => {
    const Icon = icons[name];
    return <Icon aria-hidden="true" style={{width: `${size}rem`, height: `${size}rem`}}/>;
};
export default observer(function ScheduleReportsTableHeader() {
    const {model} = useScheduleReportsListContext();
    return <Row>{ScheduleReportsTableColumns.map(column =>
        <HeaderColumn key={column.key} colKey={column.key} appearance="classic" renderIcon={renderIcon}
            defaultSortDirection={column.key === 'name' && !model.sortedColumnsOrder.length ? 1 : undefined}/>
    )}</Row>;
});
